<template>
    <div class="row gy-5">
        <div class="col-12">
            <h5 class="mb-3">Access codes</h5>
            <div class="row mb-3 gy-2 justify-content-between">
                <div class="col-md-6 col-lg-5 d-flex">
                    <div class="input-group w-auto">
                        <b-form-select style="max-width:100px;" class="form-select" v-model="itemsPerPage"
                            :options="pageOptions"></b-form-select>
                        <b-button variant="primary" @click.prevent="formContext.modal = true" type="button">
                            <i class="ri ri-add-fill align-bottom"></i> <span class="d-inline"> Create code
                            </span></b-button>
                    </div>
                </div>
                <div class="col-md-5">
                    <div class="input-group mb-0">
                        <input v-model="searchQuery" @input="updateSearchQuery" type="search" class="form-control"
                            placeholder="Search here..." aria-label="Search here..."
                            aria-describedby="button-search_TB">
                        <button @click="fetchItems()" class="btn btn-primary" type="button" id="button-search_TB"><span
                                class="ri ri-search-line"></span></button>
                    </div>
                </div>
            </div>
            <div class="mb-3">
                <p class="mb-0">Showing {{ paginationInfo }} results</p>
            </div>
            <div v-if="isLoading" class="row g-3 g-lg-4">
                <div v-for="(data, dIndex) in 3" :key="dIndex" class="col-sm-6 col-xl-4">
                    <div class="card h-100 mb-0 card-animate overflow-hidden" style="min-height: 200px;">
                        <CommonSkeletonLoader v-if="isLoading" />
                    </div>
                </div>
            </div>
            <div v-else class="row g-3 g-lg-4">
                <div v-for="(data, dIndex) in pageData.data" :key="dIndex" class="col-sm-6 col-xl-4">
                    <div class="card h-100">
                        <div class="card-body p-3 d-flex flex-column justify-content-between">
                            <div>
                                <h5 class="mb-4">{{ data.token }}</h5>
                                <p class="mb-1">Status: <strong><span v-html="statusBadge(data.status)"></span></strong></p>
                                <p class="mb-1">Expires at: <strong>{{ $filters.date(data.expired_at, 2) }}</strong></p>
                                <p class="mb-2">Created at: <strong>{{ $filters.date(data.created_at, 2) }}</strong></p>

                                <p class="mb-0 text-muted">{{ data.title }}</p>
                            </div>
                            <div class="d-grid">
                                <button class="btn btn-sm btn-warning" type="button" @click.prevent="deleteItem(data.id)">Delete</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="my-4">
                <b-pagination v-model="currentPage" :limit="pageLimit" class="pagination-rounded"
                    :total-rows="pageData.total" :per-page="itemsPerPage"></b-pagination>
            </div>
            <b-modal v-model="formContext.modal" hide-footer centered title="Access code form"
                title-class="fs-6" @hide="initializeAll()">
                <access-code-form v-if="formContext.modal" @closeMe="initializeAll()"
                    @addedItem="addItem($event)" />
            </b-modal>
        </div>
    </div>
</template>

<script>

import _ from 'lodash';

import AccessCodeForm from "@/components/forms/AccessCodeForm.vue"
import { commonSortingMixin } from '@shared/mixins/commonSortingMixin';
import { commonPaginationMixin } from '@shared/mixins/commonPaginationMixin';

export default {
    name: "access-codes",
    mixins: [
        commonSortingMixin,
        commonPaginationMixin
    ],
    components: {
        AccessCodeForm,
    },
    props: {
        program: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            isLoading: false,
            formContext: { editMode: false, modal: false, item: null },
            searchQuery: "",
            sortBy: {
                sort_column: "created_at",
                sort_direction: "asc"
            },
            pageData: {
                data: []
            },
            perPage: 10
        }
    },
    methods: {
        navigateTo(id) {

        },
        updateSearchQuery: _.debounce(function (string) {
            this.fetchItems()
        }, 2000),
        fetchItems(page, per_page = null) {
            let payload = {
                page: page || 1, per_page: per_page || this.itemsPerPage,
            }
            if (this.searchQuery) { payload.search = this.searchQuery }
            this.isLoading = true
            this.$http.get(`/access-codes?${new URLSearchParams(payload).toString()}`)
                .then((response) => {
                    this.isLoading = false
                    if (response.data.success) {
                        this.pageData = response.data.data
                        this.initializeAll()
                    }
                })
        },
        deleteItem(itemId) {
            this.confirmDelete({
                text: "You are about to delete access code permanently",
            }).then((result) => {
                if (result.value) {
                    this.$store.dispatch("changeLoaderValue", true)
                    this.$http.delete(`/access-codes/${itemId}/delete`)
                        .then(response => {
                            this.$store.dispatch("changeLoaderValue", false)
                            if (response.data.success) {
                                const ItemIndex = this.pageData.data.findIndex((item) => item.id == itemId)
                                this.pageData.data.splice(ItemIndex, 1);
                            }
                        })
                }
            });
        },
        addItem(item) {
            this.pageData.data.unshift(item);
        },
        initializeAll() {
            this.formContext = { editMode: false, modal: false, item: null };
        },
    },
    created() {
        this.fetchItems()
    },
}

</script>
